import TrusteeBasicInformation from "../../../../features/bonds/trustee/components/BasicInformation";
import TrusteeGeneralInformation from "../../../../features/bonds/trustee/components/GeneralInformation";
import Trustees from "../../../../features/bonds/trustee/components/Trustees";
import TrusteeAttorneyInformation from "../../../../features/bonds/trustee/components/AttorneyInformation";
import TrusteeRequestorInformation from "../../../../features/bonds/trustee/components/RequestorInformation";
import TrusteeDocumentUpload from "../../../../features/bonds/trustee/components/DocumentUpload";
import { BillingInformationForm } from "../Helpers/BillingInformation";
import { ObligeeInformationForm } from "../Helpers/ObligeeInformation";
import {
  getSelectedStateLabel,
  standardStep,
} from "../bondWizardPageConfig.shared";

export default {
  layout: "standard",
  inlineTitle: () =>
    `Trustee Bond Request for State of ${getSelectedStateLabel()}`,
  containerClassName: "p-6 max-w-4xl mx-auto",
  guestSupportContext: "Guest Trustee Bond Request",
  hasDuplicateDialog: true,
  hasEsignatureDialog: true,
  duplicateBondUpdatePath: (bondId) => `/vermost-trustee-bond-update/${bondId}`,
  duplicateMessage:
    "A similar trustee bond request appears to have been submitted within the last 24 hours. Do you still want to proceed?",
  getIsGuest: (form) => form.isGuestRequest,
  supportOnGoBack: ({ setSupportModalOpen }) => () => {
    setSupportModalOpen(false);
  },
  steps: [
    standardStep(TrusteeBasicInformation, "basicInformation", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.basicInformation,
      updateData: (data) => ctx.updateGlobalState("basicInformation", data),
      errors: ctx.errors,
    })),
    standardStep(TrusteeGeneralInformation, "generalInformation", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.generalInformation,
      updateData: (data) => ctx.updateGlobalState("generalInformation", data),
      errors: ctx.errors,
    })),
    standardStep(Trustees, "guardianDetails", (ctx) => ({
      data: ctx.globalState.guardianDetails,
      globalData: ctx.globalState,
      updateData: (data) => ctx.updateGlobalState("guardianDetails", data),
      isGuest: ctx.isGuest,
    })),
    standardStep(TrusteeAttorneyInformation, "attorneyInformation", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.attorneyInformation,
      updateData: (data) => ctx.updateGlobalState("attorneyInformation", data),
      isGuest: ctx.isGuest,
    })),
    standardStep(ObligeeInformationForm, "obligeeInformation", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.obligeeInformation,
      updateData: (data) => ctx.updateGlobalState("obligeeInformation", data),
      errors: ctx.errors,
      setErrors: ctx.setErrors,
    })),
    standardStep(TrusteeRequestorInformation, "requestorInformation", (ctx) => ({
      data: ctx.globalState.requestorInformation,
      updateData: (data) => ctx.updateGlobalState("requestorInformation", data),
      errors: ctx.errors,
    })),
    standardStep(TrusteeDocumentUpload, "documentUpload", (ctx) => ({
      data: ctx.globalState.documentUpload,
      updateData: (data) => ctx.updateGlobalState("documentUpload", data),
    })),
    standardStep(BillingInformationForm, "billingInformation", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.billingInformation,
      updateData: (data) => ctx.updateGlobalState("billingInformation", data),
      errors: ctx.errors,
      setErrors: ctx.setErrors,
      isGuest: ctx.isGuest,
    })),
  ],
};
